//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState, mapGetters, mapActions } from 'vuex';
import constant from '~/const';
import Filters from './TableFilters.vue';
import CryptomatsAtmsExtra from './CryptomatsAtmsExtra/CryptomatsAtmsExtra.vue';

import tableConfig from './tableConfig';

export default {
  components: {
    Filters,
    CryptomatsAtmsExtra,
  },

  data() {
    return {
      tableConfig,
      constant,
    };
  },

  async mounted() {
    this.setGeneralLoader(true);
    await Promise.allSettled([
      this.loadDataAction(),
      this.getCurrencies(),
    ]);
    this.setGeneralLoader(false);
  },

  computed: {
    ...mapState('common', ['generalLoader']),
    ...mapGetters('common', ['itemsPerPage']),

    ...mapState('cryptomatsAtms', ['page', 'pages', 'filters', 'atms']),
  },

  methods: {
    ...mapActions('common', [
      'setGeneralLoader',
      'setGeneralProgress',
      'setSuccessNotification',
      'setErrorNotification',
      'confirmAction',
    ]),
    ...mapActions('currencies', ['getCurrencies']),
    ...mapActions('cryptomatsAtms', {
      loadDataAction: 'loadAtms',
      setPageAction: 'setPage',
      deleteAtmAction: 'deleteAtm',
      deleteCoupleAction: 'deleteCouple',
      editLimitAction: 'editLimit',
    }),

    getType(row) {
      const { buyStatus: buy, sellStatus: sell } = row;

      if (!buy && !sell) return 'No';
      if (buy && sell) return 'Buy/Sell';
      return buy ? 'Buy' : 'Sell';
    },

    supportedList(list) {
      return list.map((title, index) => `${title}${index < list.length - 1 ? ', ' : ''}`).join('');
    },

    async loadData(data = {}) {
      this.setGeneralProgress(true);
      await this.loadDataAction(data);
      this.setGeneralProgress(false);
    },

    applyFilters() {
      const { page } = this;
      if (page > 1) {
        this.setPageAction(1);
        this.$router.replace({ query: {} });
      }

      this.loadData();
    },

    setPage(value) {
      this.setPageAction(value);

      const extendedRequestData = {
        getTotal: false,
      };

      this.loadData(extendedRequestData);
    },

    deleteCouple(couple) {
      this.confirmAction({
        title: 'Delete couple',
        text: 'Are you sure you want to delete this couple?',
        callback: async () => {
          this.setGeneralLoader(true);
          try {
            await this.deleteCoupleAction(couple);
            this.setSuccessNotification('You have successfully deleted the couple');
            this.loadData();
          } catch (error) {
            this.setErrorNotification('Unable to delete the couple');
          }
          this.setGeneralLoader(false);
        },
      });
    },

    deleteAtm(atm) {
      this.confirmAction({
        title: 'Delete ATM',
        text: 'Are you sure you want to delete this ATM?',
        callback: async () => {
          this.setGeneralLoader(true);
          try {
            await this.deleteAtmAction(atm.frontId);
            this.setSuccessNotification('You have successfully deleted the ATM');
            this.loadData();
          } catch (error) {
            this.setErrorNotification('Unable to delete the ATM');
          }
          this.setGeneralLoader(false);
        },
      });
    },
  },
};
